import { MODESTATE } from '@view/page_v3/AiEdit/CONST'

export default function useCircleSelection(fabricInstanceRef, operateTypeRef, drawingRef, getIsDraw, points, modeStateRef) {

    const updateCirclePosition = (event) => {
        const activeObject = fabricInstanceRef.current.getActiveObject();
        if (activeObject || !drawingRef.current) {
            return;
        }

        if (operateTypeRef.current === 'circle' && points.length > 0) {
            const { offsetX, offsetY } = event.e;
            const canvasOffsetX = fabricInstanceRef.current.viewportTransform[4];
            const canvasOffsetY = fabricInstanceRef.current.viewportTransform[5];
            const zoom = fabricInstanceRef.current.getZoom();
            const x = (offsetX - canvasOffsetX) / zoom;
            const y = (offsetY - canvasOffsetY) / zoom;

            const canvasWidth = fabricInstanceRef.current.width;
            const canvasHeight = fabricInstanceRef.current.height;
            if (x < 0 || x > canvasWidth || y < 0 || y > canvasHeight) {
                endCircle();
                return false;
            }

            points.push([x, y]);

            fabricInstanceRef.current.getObjects().forEach((obj) => {
                if (obj._isTemporaryPath) {
                    fabricInstanceRef.current.remove(obj);
                }
            });

            const pathData = `M ${points[0][0]} ${points[0][1]} ` +
                points.slice(1).map(p => `L ${p[0]} ${p[1]}`).join(' ');

            const path = new fabric.Path(pathData, {
                fill: '',
                stroke: modeStateRef.current == MODESTATE.ERASER? 'rgba(240, 72, 72, 1)': 'rgba(30, 144, 255, 0.8)',
                strokeWidth: 2,
                strokeDashArray: [5, 5],
                selectable: false,
                evented: false,
                _isTemporaryPath: true
            });

            fabricInstanceRef.current.add(path);
            fabricInstanceRef.current.renderAll();
        }
    };

    const endCircle = () => {
        const activeObject = fabricInstanceRef.current.getActiveObject();
        if (activeObject) return;


        if (points.length < 5) {
            clearTemporaryPaths();
            points.length = 0;
            return;
        }

        if (operateTypeRef.current === 'circle' && points.length > 0) {
            points.push(points[0]);

            const pathData = `M ${points[0][0]} ${points[0][1]} ` +
                points.slice(1).map(p => `L ${p[0]} ${p[1]}`).join(' ') + ' Z';

            const path = new fabric.Path(pathData, {
                fill: modeStateRef.current == MODESTATE.ERASER? ' ': 'rgba(30, 144, 255, 0.8)',
                selectable: true,
                evented: true,
                selectable: false,
                evented: false,
                cornerSize: 8,
                globalCompositeOperation: modeStateRef.current == MODESTATE.ERASER? 'destination-out' : 'source-over'
            });

            path.setControlsVisibility({ mtr: false });

            fabricInstanceRef.current.add(path);
            points.length = 0;

            clearTemporaryPaths();

            const circleList = fabricInstanceRef.current.getObjects().filter(item => item.type === 'path');
            getIsDraw(circleList);
        }
    };

    const clearTemporaryPaths = () => {
        fabricInstanceRef.current.getObjects().forEach((obj) => {
            if (obj._isTemporaryPath) fabricInstanceRef.current.remove(obj);
        });
        fabricInstanceRef.current.renderAll();
    };

    return {
        updateCirclePosition,
        endCircle,
        clearTemporaryPaths,
    };
}
